<template>
  <div>
    <div class="form-container">
      <div class="form-title margin-b-20">评价信息</div>
      <div class="margin-b-20">
        <evaluation-info :evaluationInfo="evaluationInfo"></evaluation-info>
      </div>
      <div>
        <evaluation-info-table
          :evaluationInfo="evaluationInfo"
        ></evaluation-info-table>
      </div>
    </div>

    <div class="form-container">
      <div class="form-title margin-b-20">业务咨询人</div>
      <consult-table :evaluationInfo="evaluationInfo"></consult-table>
    </div>

    <!-- <div class="flex-sb">
      <div>
        <eui-btn type="secondary" @click="goBack">返回</eui-btn>
      </div>
      <div>
        <eui-btn type="secondary" style="margin-right: 10px"
          >下载评价办法</eui-btn
        >
        <eui-btn type="secondary">下载评价细则</eui-btn>
      </div>
    </div> -->
  </div>
</template>

<script>
import evaluationInfoTable from './evaluationInfoTable.vue';
import consultTable from './consultTable.vue';
import evaluationInfo from './evaluationInfo.vue';
import Api from '@/modules/projectA/api/ESorganization';
export default {
  data() {
    return {
      evaluationId: '',
      evaluationInfo: {}
    };
  },
  components: {
    evaluationInfoTable,
    consultTable,
    evaluationInfo
  },
  computed: {},
  created() {
    const { evaluationId = '' } = this.$route.query;
    this.evaluationId = evaluationId;
  },
  mounted() {
    this.nonStructEvaluationDetail(this.evaluationId);
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/ES/ESorganization'
      });
    },
    async nonStructEvaluationDetail(id) {
      let query = {
        evaluationId: id
      };
      let info = await Api.nonStructEvaluationDetail(query);
      this.evaluationInfo = info.data;
    }
  }
};
</script>
<style lang="scss" scoped>
.margin-b-20 {
  margin-bottom: 20px;
}
.form-title {
  font-weight: 500;
}
</style>
